// extracted by mini-css-extract-plugin
module.exports = {"tabDiv":"tabDiv__1PVYx","tab":"tab__tBo7Y","tabActive":"tabActive__26iyV"};